import React from "react";
import styled from "styled-components";
import { b } from "../../styles/variables";
import { FlxCenter, FlxColumn } from "../../styles/globalStyles";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  addToCart,
  decreaseCart,
  removeFromCart,
  getTotals,
  clearCart,
  updateCartCredit,
} from "../../redux/feature/cartSlice";
import { useEffect } from "react";
import { placeOrder } from "../../redux/feature/orderSlice";
import { toast } from "react-hot-toast";
import { useState } from "react";
import { ROLES } from "../FoodAppConstants";
import { AVAILS } from "../MenuCard";
import { TextContainer } from "../../styles/globalStyles";
import { FoodTag } from "@styled-icons/boxicons-regular/FoodTag";
import {Trash} from "@styled-icons/boxicons-regular/Trash";

function Cart() {
  const navigate = useNavigate();
  const cart = useSelector((state) => state.cart);
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [time, setTime] = useState(new Date());
  const [isAdmin, setIsAdmin] = useState(false);
  const [isDisabled, SetIsDisabled] = useState(false);
  const bcutoff = "0930";
  const lcutoff = "1200";
  const scutoff = "1700";
  const socutoff = "2030";

  useEffect(() => {
    dispatch(getTotals(auth.creds.usercredit));
    const setRole = () => {
      if (auth.creds.roleslist.includes(ROLES["Admin"])) {
        setIsAdmin(true);
      } else {
        setIsAdmin(false);
      }
    };
    setRole();
  }, [cart]);

  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  const formatedTime = time
    .toLocaleTimeString("it-IT", {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
    })
    .replace(/:/g, "");

  const handleAddToCart = (food, type) => {
    dispatch(addToCart([food, type]));
  };
  const handleDecreaseCart = (food, type) => {
    dispatch(decreaseCart([food, type]));
  };
  const handleRemoveFromCart = (food) => {
    dispatch(removeFromCart([food]));
  };
  const handleClearCart = () => {
    dispatch(clearCart());
    toast.success("Cart Cleared", {
      position: "bottom-right",
      duration: 5000,
    });
  };

  const handlePlaceOrder = (
    cartItems,
    time,
    bcutoff,
    lcutoff,
    scutoff,
    socutoff,
    isAdmin
  ) => {
    let status = "";
    const orderList = { BREAKFAST: [], LUNCH: [], SNACK: [], SELF_ORDER:[] };
    cartItems.map((cartItem, index) => {
      if (cartItem.cartQuantity[0] > 0) {
        if (time < bcutoff || isAdmin) {
          orderList.BREAKFAST.push(cartItem);
          orderList.BREAKFAST[orderList.BREAKFAST.length - 1] = {
            ...orderList.BREAKFAST[orderList.BREAKFAST.length - 1],
            cartQuantity:
              orderList.BREAKFAST[orderList.BREAKFAST.length - 1]
                .cartQuantity[0],
          };
        } else {
          toast.error(
            "Couldn't Place Order, Please make Breakfast Qty as zero"
          );
          status = "stoped";
          return status;
        }
      }
      if (cartItem.cartQuantity[1] > 0) {
        if (time < lcutoff || isAdmin) {
          orderList.LUNCH.push(cartItem);
          orderList.LUNCH[orderList.LUNCH.length - 1] = {
            ...orderList.LUNCH[orderList.LUNCH.length - 1],
            cartQuantity:
              orderList.LUNCH[orderList.LUNCH.length - 1].cartQuantity[1],
          };
        } else {
          toast.error("Couldn't Place Order, Please make Lunch Qty as zero");
          status = "stoped";
          return status;
        }
      }
      if (cartItem.cartQuantity[2] > 0) {
        if (time < scutoff || isAdmin) {
          orderList.SNACK.push(cartItem);
          orderList.SNACK[orderList.SNACK.length - 1] = {
            ...orderList.SNACK[orderList.SNACK.length - 1],
            cartQuantity:
              orderList.SNACK[orderList.SNACK.length - 1].cartQuantity[2],
          };
        } else {
          toast.error("Couldn't Place Order, Please make Snacks Qty as zero");
          status = "stoped";
          return status;
        }
      }
      if (cartItem.cartQuantity[3] > 0) {
        if (time < socutoff || isAdmin) {
          orderList.SELF_ORDER.push(cartItem);
          orderList.SELF_ORDER[orderList.SELF_ORDER.length - 1] = {
            ...orderList.SELF_ORDER[orderList.SELF_ORDER.length - 1],
            cartQuantity:
              orderList.SELF_ORDER[orderList.SELF_ORDER.length - 1].cartQuantity[3],
          };
        } else {
          toast.error("Couldn't Place Order, Please make self order Qty as zero");
          status = "stoped";
          return status;
        }
      }
    });
    if (status === "stoped") {
      return;
    } else {
      dispatch(placeOrder([orderList]));
      navigate("/");
    }
  };

  return (
    <MainContainer>
      <ContentWrapper>
        {cart?.cartItems.length === 0 ? (
          <EmptyState>
            <EmptyEmoji role="img" aria-label="empty">&#127869;</EmptyEmoji>
            <EmptyTitle>Your cart is empty</EmptyTitle>
            <EmptyText>Add something delicious to get started!</EmptyText>
            <Link to="/fooddata/foodall" style={{ textDecoration: 'none' }}>
              <OrderButton>Browse Menu</OrderButton>
            </Link>
          </EmptyState>
        ) : (
          <>
            <CartHeader>
              <CartTitle>Your Cart ({cart.cartTotalQuantity} items)</CartTitle>
            </CartHeader>
            
            <CartBody>
              {cart?.cartItems &&
                cart.cartItems.map((cartItem) => (
                  <CartItemCard key={cartItem?.food_id}>
                    <ItemInfo>
                      <ItemNameRow>
                        <FoodTag size={16} color={cartItem.food_source === "VEG" ? "#22c55e" : "#ef4444"} />
                        <ItemName>{cartItem.food_name}</ItemName>
                      </ItemNameRow>
                      {cartItem.food_description && (
                        <ItemDescription>{cartItem.food_description}</ItemDescription>
                      )}
                      <ItemVendor>{cartItem.vendor.vendor_name}</ItemVendor>
                      {cartItem.availabilities.length !== 0 && (
                        <AvailRow>
                          {cartItem.availabilities?.map((item, index) => (
                            <AvailChip key={index}>{AVAILS[item]}</AvailChip>
                          ))}
                        </AvailRow>
                      )}
                      <RemoveButton onClick={() => handleRemoveFromCart(cartItem.food_id)}>
                        <Trash size={14} /> Remove
                      </RemoveButton>
                    </ItemInfo>

                    <ItemPriceCol>
                      <ColLabel>Price</ColLabel>
                      <ColValue>{cartItem?.food_price}</ColValue>
                    </ItemPriceCol>

                    <QtySection>
                      <MealQtyRow>
                        <MealLabel>Breakfast</MealLabel>
                        <QtyControl disabled={formatedTime >= bcutoff && !isAdmin}>
                          <QtyBtn
                            disabled={cartItem?.cartQuantity[0] <= 0}
                            onClick={() => handleDecreaseCart(cartItem, "B")}
                          >-</QtyBtn>
                          <QtyValue>{cartItem?.cartQuantity[0]}</QtyValue>
                          <QtyBtn
                            disabled={formatedTime >= bcutoff && !isAdmin}
                            onClick={() => handleAddToCart(cartItem, "B")}
                          >+</QtyBtn>
                        </QtyControl>
                      </MealQtyRow>

                      <MealQtyRow>
                        <MealLabel>Lunch</MealLabel>
                        <QtyControl disabled={formatedTime >= lcutoff && !isAdmin}>
                          <QtyBtn
                            disabled={cartItem.cartQuantity[1] <= 0}
                            onClick={() => handleDecreaseCart(cartItem, "L")}
                          >-</QtyBtn>
                          <QtyValue>{cartItem.cartQuantity[1]}</QtyValue>
                          <QtyBtn
                            disabled={formatedTime >= lcutoff && !isAdmin}
                            onClick={() => handleAddToCart(cartItem, "L")}
                          >+</QtyBtn>
                        </QtyControl>
                      </MealQtyRow>

                      <MealQtyRow>
                        <MealLabel>Snacks</MealLabel>
                        <QtyControl disabled={formatedTime >= scutoff && !isAdmin}>
                          <QtyBtn
                            disabled={cartItem.cartQuantity[2] <= 0}
                            onClick={() => handleDecreaseCart(cartItem, "S")}
                          >-</QtyBtn>
                          <QtyValue>{cartItem.cartQuantity[2]}</QtyValue>
                          <QtyBtn
                            disabled={formatedTime >= scutoff && !isAdmin}
                            onClick={() => handleAddToCart(cartItem, "S")}
                          >+</QtyBtn>
                        </QtyControl>
                      </MealQtyRow>

                      <MealQtyRow>
                        <MealLabel>Self-Order</MealLabel>
                        <QtyControl disabled={formatedTime >= socutoff && !isAdmin}>
                          <QtyBtn
                            disabled={cartItem?.cartQuantity[3] <= 0}
                            onClick={() => handleDecreaseCart(cartItem, "SB")}
                          >-</QtyBtn>
                          <QtyValue>{cartItem?.cartQuantity[3] || 0}</QtyValue>
                          <QtyBtn
                            disabled={formatedTime >= socutoff && !isAdmin}
                            onClick={() => handleAddToCart(cartItem, "SB")}
                          >+</QtyBtn>
                        </QtyControl>
                      </MealQtyRow>
                    </QtySection>

                    <ItemTotalCol>
                      <ColLabel>Total</ColLabel>
                      <ColValue>{cartItem.itemTotal}</ColValue>
                    </ItemTotalCol>
                  </CartItemCard>
                ))}
            </CartBody>

            <CartFooter>
              <TotalRow>
                <TotalLabel>Order Total</TotalLabel>
                <TotalAmount>{cart.cartTotalAmount}</TotalAmount>
              </TotalRow>
              <ActionRow>
                <SecondaryBtn onClick={() => navigate(-1)}>Order More</SecondaryBtn>
                <SecondaryBtn onClick={() => handleClearCart()}>Clear Cart</SecondaryBtn>
                <PrimaryBtn
                  disabled={cart.cartTotalQuantity <= 0}
                  onClick={() =>
                    handlePlaceOrder(
                      cart.cartItems,
                      formatedTime,
                      bcutoff,
                      lcutoff,
                      scutoff,
                      socutoff,
                      isAdmin
                    )
                  }
                >
                  Place Order
                </PrimaryBtn>
              </ActionRow>
            </CartFooter>
          </>
        )}
      </ContentWrapper>
    </MainContainer>
  );
}

export default Cart;

const MainContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  overflow-y: auto;
  padding: 2rem;

  @media ${b.mobile} {
    padding: 1rem;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 900px;

  @media ${b.mobile} {
    max-width: 100%;
  }
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6rem 2rem;
  background: #fff;
  border-radius: 16px;
  border: 1px solid #f4f4f5;
  margin-top: 2rem;
`;

const EmptyEmoji = styled.span`
  font-size: 6rem;
  margin-bottom: 1.5rem;
`;

const EmptyTitle = styled.h2`
  font-size: 2.2rem;
  font-weight: 700;
  color: #1e1e2d;
  margin-bottom: 0.5rem;
`;

const EmptyText = styled.p`
  font-size: 1.4rem;
  color: #71717a;
  margin-bottom: 2rem;
`;

const OrderButton = styled.button`
  background: linear-gradient(135deg, #F7707D 0%, #F29173 100%);
  border: none;
  color: white;
  padding: 1.2rem 3rem;
  border-radius: 12px;
  font-size: 1.5rem;
  font-weight: 600;
  cursor: pointer;
  font-family: 'Nunito Sans', sans-serif;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(247, 112, 125, 0.3);
  }
`;

const CartHeader = styled.div`
  margin-bottom: 1.6rem;
`;

const CartTitle = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  color: #1e1e2d;
`;

const CartBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

const CartItemCard = styled.div`
  display: flex;
  align-items: stretch;
  background: #ffffff;
  border: 1px solid #f4f4f5;
  border-radius: 14px;
  overflow: hidden;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
    border-color: transparent;
  }

  @media ${b.mobile} {
    flex-direction: column;
  }
`;

const ItemInfo = styled.div`
  flex: 2;
  padding: 1.4rem 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  border-right: 1px solid #f4f4f5;

  @media ${b.mobile} {
    border-right: none;
    border-bottom: 1px solid #f4f4f5;
  }
`;

const ItemNameRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const ItemName = styled.span`
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e1e2d;
  overflow-wrap: break-word;
  word-break: break-word;
`;

const ItemDescription = styled.p`
  font-size: 1.15rem;
  color: #71717a;
  line-height: 1.3;
`;

const ItemVendor = styled.span`
  font-size: 1.15rem;
  color: #a1a1aa;
  font-weight: 500;
`;

const AvailRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
`;

const AvailChip = styled.span`
  font-size: 1rem;
  background: #f4f4f5;
  color: #52525b;
  padding: 2px 8px;
  border-radius: 6px;
  font-weight: 500;
`;

const RemoveButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  color: #ef4444;
  cursor: pointer;
  font-size: 1.15rem;
  font-weight: 500;
  padding: 8px 4px;
  min-height: 36px;
  margin-top: 0.3rem;
  font-family: 'Nunito Sans', sans-serif;
  transition: opacity 0.2s;
  align-self: flex-start;
  -webkit-tap-highlight-color: transparent;

  &:hover, &:active {
    opacity: 0.7;
  }
`;

const ColLabel = styled.span`
  font-size: 1rem;
  color: #a1a1aa;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const ColValue = styled.span`
  font-size: 1.8rem;
  font-weight: 800;
  color: #1e1e2d;
`;

const ItemPriceCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem 1.5rem;
  border-right: 1px solid #f4f4f5;
  min-width: 90px;

  @media ${b.mobile} {
    display: none;
  }
`;

const QtySection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem 1.5rem;
  gap: 0.5rem;
  border-right: 1px solid #f4f4f5;
  min-width: 180px;

  @media ${b.mobile} {
    border-right: none;
    border-bottom: 1px solid #f4f4f5;
    min-width: auto;
  }
`;

const MealQtyRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.8rem;
`;

const MealLabel = styled.span`
  font-size: 1.15rem;
  font-weight: 600;
  color: #52525b;
  min-width: 72px;
`;

const QtyControl = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid ${({disabled}) => disabled ? '#e4e4e7' : '#d4d4d8'};
  border-radius: 8px;
  overflow: hidden;
  background: ${({disabled}) => disabled ? '#f4f4f5' : '#fff'};
  opacity: ${({disabled}) => disabled ? 0.5 : 1};
`;

const QtyBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  cursor: ${({disabled}) => disabled ? 'not-allowed' : 'pointer'};
  font-size: 1.8rem;
  font-weight: 600;
  color: ${({disabled}) => disabled ? '#d4d4d8' : '#1e1e2d'};
  transition: background 0.15s;
  -webkit-tap-highlight-color: transparent;

  &:hover:not(:disabled), &:active:not(:disabled) {
    background: #f4f4f5;
  }
`;

const QtyValue = styled.span`
  font-size: 1.4rem;
  font-weight: 700;
  color: #1e1e2d;
  min-width: 24px;
  text-align: center;
`;

const ItemTotalCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem 1.5rem;
  min-width: 90px;

  @media ${b.mobile} {
    flex-direction: row;
    justify-content: space-between;
    padding: 1rem 1.6rem;
    gap: 6px;
  }
`;

const CartFooter = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #f4f4f5;
  border-radius: 14px;
  margin-top: 2rem;
  padding: 2rem;
  margin-bottom: 4rem;
`;

const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #f4f4f5;
  margin-bottom: 1.5rem;
`;

const TotalLabel = styled.span`
  font-size: 1.8rem;
  font-weight: 700;
  color: #1e1e2d;
`;

const TotalAmount = styled.span`
  font-size: 2.4rem;
  font-weight: 800;
  color: #F7707D;
`;

const ActionRow = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;

  @media ${b.mobile} {
    flex-direction: column;
  }
`;

const SecondaryBtn = styled.button`
  padding: 1rem 2rem;
  min-height: 44px;
  border-radius: 10px;
  border: 1.5px solid #e4e4e7;
  background: #fff;
  color: #52525b;
  font-size: 1.35rem;
  font-weight: 600;
  cursor: pointer;
  font-family: 'Nunito Sans', sans-serif;
  transition: all 0.2s ease;
  -webkit-tap-highlight-color: transparent;

  &:hover, &:active {
    border-color: #F7707D;
    color: #F7707D;
    background: rgba(247, 112, 125, 0.04);
  }

  @media ${b.mobile} {
    width: 100%;
  }
`;

const PrimaryBtn = styled.button`
  padding: 1rem 3rem;
  min-height: 44px;
  border-radius: 10px;
  border: none;
  background: linear-gradient(135deg, #F7707D 0%, #F29173 100%);
  color: white;
  font-size: 1.35rem;
  font-weight: 700;
  cursor: pointer;
  font-family: 'Nunito Sans', sans-serif;
  transition: all 0.2s ease;
  -webkit-tap-highlight-color: transparent;

  &:hover:not(:disabled), &:active:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(247, 112, 125, 0.35);
  }

  &:disabled {
    background: #d4d4d8;
    cursor: not-allowed;
  }

  @media ${b.mobile} {
    width: 100%;
  }
`;
